import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import {isDesktop, isMobile, isTablet} from "@/Helpers/Function";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
// import Slider from "react-slick";
import {Breadcrumbs} from "@mui/material";
import ScrollMagic from "scrollmagic/scrollmagic/uncompressed/ScrollMagic";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import '@/Pages/Collections/scss/minima.scss';

class Minima extends React.Component {
    componentDidMount = () => {
        reachGoalYM('minima');
        reachGoalGA('minima');
        this.sceneAll()
    };

    sceneAll = () => {
        const controller = new ScrollMagic.Controller();
        new ScrollMagic.Scene({
            triggerElement: "#descriptionMinima",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#descriptionMinima", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#bright-minimalism",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#bright-minimalism", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#stylistics-geometry-info",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#stylistics-geometry-info", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#wrap_2",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#wrap_2", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#wrap_3",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#wrap_3", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#wrap_4",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#wrap_4", "visible")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#wrap_6",
            triggerHook: 0.9,
            offset: 100,
        })
            .setClassToggle("#wrap_6", "visible")
            .addTo(controller);
    }


    render() {
        const {stores = {}, uploadUrl = ''} = this.props;
        const {modalStore = {}, collectionsStore = {}} = stores;

        const AddAiOutlineArrowLeft = (props) => (
            <div className={`arrows-collections arrows-collections__left`} onClick={props.onClick}></div>
        );

        const AddAiOutlineArrowRight = (props) => (
            <div className={`arrows-collections arrows-collections__right`} onClick={props.onClick}></div>
        );

        const settings = {
            autoplay: false,
            autoplaySpeed: 3000,
            speed: 500,
            infinite: true,
            dots: false,
            dotsClass: 'slick-main-dots',
            fade: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: false,
            className: '',
            prevArrow: <AddAiOutlineArrowLeft />,
            nextArrow: <AddAiOutlineArrowRight />,
            appendDots: dots => (
                <ul> {dots} </ul>
            ),
            customPaging: () => (
                <span></span>
            )
        };
        const settings1 = {
            autoplay: false,
            autoplaySpeed: 3000,
            speed: 500,
            infinite: false,
            dots: false,
            dotsClass: 'slick-main-dots',
            fade: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: false,
            className: '',
        };
        const element = collectionsStore.minimaData.map((el) => {
            return <div key={el.id}
                        className={`slider__item`}>
                <img key={el.id}
                     className={`image`}
                     loading={`lazy`}
                     src={el.imgPath}
                     alt={`Красивое фото`}
                     title={`Красивое фото`}
                />
            </div>;
        });

        const element1 = collectionsStore.minimaStepsData.map((el) => {
            return <div key={el.id}
                        className={`steps__item`}>
                <img key={el.id}
                     loading={`lazy`}
                     src={el.imgPath}
                     alt={`Красивое фото`}
                     title={`Красивое фото`}
                />
                <p className={`steps__info`}>{el.text}</p>
            </div>;
        });

        return <>
            <section className={`section`}>
                <div className={`breadcrumbs`}>
                    <div className="container">
                        <Breadcrumbs maxItems={3} itemsAfterCollapse={3}>
                            <Link className={`breadcrumbs__link`} href={`/$`}>
                                Главная
                            </Link>
                            <Link className={`breadcrumbs__link`} href={`/collections`}>
                                Коллекции
                            </Link>
                            <p className={`breadcrumbs__text`}>
                                MINIMA
                            </p>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className={`collections-lp`}>
                    <div className={`container`}>
                        <div className={`minima-video`}>
                            <div className={`video-box`}>
                                {isDesktop() || isTablet() ?
                                    <video id={`video`}
                                           width={`100%`}
                                           preload={`none`}
                                           poster={`/storage/img/collections/minima/video-poster.jpg`}
                                    >
                                        <source src={`${uploadUrl}/media/video/collections/minima/minima_1280х720.mp4`}
                                                type={`video/mp4`} />
                                    </video>
                                    :
                                    <video id={`video`}
                                           width={`100%`}
                                           preload={`metadata`}
                                           poster={`/storage/img/collections/minima/video-poster-mobile.jpg`}
                                    >
                                        <source src={`${uploadUrl}/media/video/collections/minima/minima-mobile.mp4`}
                                                type={`video/mp4`} />
                                        <source src={`${uploadUrl}/media/video/collections/minima/minima-mobile.webm`}
                                                type={`video/webm`} />
                                        <source src={`${uploadUrl}/media/video/collections/minima/minima-mobile.ogg`}
                                                type={`video/ogg`} />
                                    </video>
                                }
                            </div>
                            <div className={`video-control`}
                                 onClick={() => collectionsStore.mediaNorthernLightsMainPlayPause()}>
                                {collectionsStore.videoMinimaSvg ?
                                    <>
                                        <div className={`gg-play-button`}
                                             onClick={() => collectionsStore.mediaMinima()}></div>
                                    </>
                                    :
                                    <>
                                        {collectionsStore.videoNorthernLightsMainPlayPauseFlag ?
                                            <div className={`gg-pause-button`}
                                                 onClick={() => collectionsStore.mediaMinima()}></div>
                                            : null
                                        }
                                    </>
                                }
                            </div>
                            {isDesktop() ?
                                <>
                                    <div className={`minima-video__create`}>Создавай</div>
                                    <div className={`minima-video__trends`}>тренды</div>
                                </> :
                                <div className={`minima-video__create-trends`}>Создавай тренды</div>
                            }
                        </div>

                        <div id="descriptionMinima" className={`description description__top`}>
                            <p>Изящность простых геометрических форм&nbsp;&mdash; твой новый источник вдохновения.
                                Коллекция серебряных украшений
                                <span className={`minima-small`}>&laquo;Minima&raquo;</span>
                                раскроет для тебя секрет истинной привлекательности!
                                Отсекая лишнее, ты&nbsp;увидишь саму суть красоты. Твой ответ&nbsp;&mdash; это стиль
                                минимал. Идея, которая станет частью твоего жизненного пространства.
                            </p>
                        </div>
                    </div>
                    <div id={`bright-minimalism`} className={`minima__wrap_1`}>
                        <div className={`container`}>
                            <div className={`bright-minimalism`}>
                                <div className={`bright-minimalism__left`}>
                                    <div className={`bright-minimalism__title`}>
                                        <p className={`bright`}>
                                            Яркий
                                            <Svg id={`bright`} className={`svg__bright`} />
                                        </p>
                                        <p className={`minimalism`}>мнмлзм</p>
                                    </div>
                                    <div className={`bright-minimalism__img-left`}>
                                        <img className={``}
                                             src={`/storage/img/collections/minima/foto-1.png`}
                                             loading={`lazy`}
                                             alt={`Яркий мнмлзм`}
                                             title={`Яркий мнмлзм`}
                                        />
                                    </div>
                                    <div className={`description__bright-minimalism`}>
                                        <p>
                                            Тренд, завоевавший наше сегодня и&nbsp;открывающий двери в&nbsp;завтра!
                                            Его не&nbsp;смущают веяния моды&nbsp;&mdash; он&nbsp;сам диктует модные
                                            тенденции. Ведь изысканная простота&nbsp;&mdash; это ключ
                                            к&nbsp;совершенству.
                                        </p>
                                    </div>
                                </div>
                                <div id={`minimalismRight`} className={`bright-minimalism__right`}>
                                    <div className={`bright-minimalism__text`}>
                                        <p className={`collection`}>
                                            Коллекция
                                            <Svg id={`wave`} className={`svg__wave`} />
                                        </p>
                                        <p className={`minima`}>MINIMA</p>
                                        <p className={`desc`}>выводит подлинную красоту и&nbsp;уникальность
                                            на&nbsp;передний план. Создай свой идеальный баланс в&nbsp;образе
                                            с&nbsp;украшениями от&nbsp;PLATINA. Узнай, с&nbsp;чего начинается твоё
                                            совершенство...
                                        </p>
                                    </div>
                                    <div className={`bright-minimalism__img-right`}>
                                        <Link
                                            href={`/catalog/product/02-4615-00-000-0200-71?utm_source=lp_minima&utm_medium=product_02-4615-00-000-0200-71&utm_campaign=l`}>
                                            <img className={``}
                                                 loading={`lazy`}
                                                 src={`/storage/img/collections/minima/earring_1.png`}
                                                 alt={`Коллекция MINIMA выводит подлинную красоту и уникальность на передний план.`}
                                                 title={`Коллекция MINIMA выводит подлинную красоту и уникальность на передний план.`}
                                            />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`container`}>
                        <div id={`stylistics-geometry-info`}>
                            <p className={`stylistics-geometry-info`}>
                                <span className={`stylistics-geometry-info__dedicated`}>
                                    Стилистика геометрии и&nbsp;космоса&nbsp;
                                </span>
                                &mdash; это новая классика! Почувствуй всю
                                красоту и&nbsp;волшебство роскошного, нежного серебра. Его
                                завораживающий &laquo;лунный&raquo; блеск&nbsp;&mdash; лучшее воплощение твоей
                                уникальности
                            </p>
                        </div>
                    </div>
                    <div id={`wrap_2`} className={`minima__wrap_2`}>
                        <div id="animateCat" className={`cat cat__desktop`}>
                            {isMobile() ?
                                <img src={`/storage/img/collections/minima/cat-mobile.png`} alt={`Фото`} title={`Фото`}
                                     loading={`lazy`} />
                                :
                                <img src={`/storage/img/collections/minima/cat.png`} alt={`Фото`} title={`Фото`}
                                     loading={`lazy`} />
                            }
                        </div>
                        <div className={`bg_beige`}></div>
                        <div className={`container`}>
                            <div className={`minima__wrapper`}>
                                <div className={`minima__item minima__item_img`}>
                                    <Link
                                        href={`/catalog/product/02-4619-00-000-0200-71?utm_source=lp_minima&utm_medium=product_02-4619-00-000-0200-71&utm_campaign=l`}>
                                        <img className={``}
                                             src={`/storage/img/collections/minima/earring_2.png`}
                                             alt={`Красивое фото`}
                                             title={`Красивое фото`}
                                        />
                                    </Link>
                                </div>
                                <div className={`minima__item minima__item_info`}>
                                    <div className={`dynamic-fast`}>
                                        <p className={`dynamic-fast__title dynamic-fast__title_1`}>
                                            Лаконичность
                                            <Svg id={`wave`} className={`svg__wave`} />
                                        </p>
                                        <p className={`dynamic-fast__info`}>
                                            Изысканные силуэты и&nbsp;простота форм в&nbsp;сочетании
                                            с&nbsp;очаровательным оттенком серебра дарит незабываемое впечатление.
                                        </p>
                                        <p className={`dynamic-fast__title dynamic-fast__title_2`}>
                                            Динамичность
                                            <Svg id={`wave`} className={`svg__wave`} />
                                            и&nbsp;стремительность
                                        </p>
                                        <p className={`dynamic-fast__info`}>
                                            Идея вечного движения и&nbsp;вечного стремления к&nbsp;совершенству.
                                            Настоящий простор для экспериментов в&nbsp;создании образа.
                                        </p>
                                        <p className={`dynamic-fast__description`}>
                                                <span>
                                                    Эти украшения&nbsp;&mdash; для тех, кто чувствует истинную красоту,
                                                    скрытую в&nbsp;изяществе и&nbsp;простоте. Кто ценит натуральное
                                                    и&nbsp;знает, что наивная лёгкость&nbsp;&mdash; это искусство!
                                                </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id={`wrap_3`} className={`minima__wrap_3`}>
                        <div className={`yours-decorations`}>
                            <div className={`container`}>
                                <div className={`minima__wrapper minima__wrapper_yours-decorations`}>
                                    <div className={`minima__item minima__item_information`}>
                                        <p className={`title__yours-decorations`}>
                                            Твои украшения на&nbsp;каждый день
                                            <Svg id={`tripleChevron`} className={`svg__tripleChevron`} />
                                        </p>
                                        <p className={`description__yours-decorations`}>
                                            Идеально дополнят твой образ там и&nbsp;тогда, где это необходимо.
                                            Оставаться стильной каждый день легко, если
                                            ты&nbsp;с&nbsp;украшениями &laquo;Minima&raquo;.
                                        </p>
                                        <p className={`description__yours-decorations`}>
                                            Эти украшения&nbsp;&mdash; твой путь к&nbsp;новым впечатлениям! Заяви
                                            о&nbsp;своём вкусе. Почувствуй их&nbsp;дизайн. Укрась свой стиль!
                                        </p>
                                    </div>
                                    <div className={`minima__item minima__item_box-img`}>
                                        <div className={`lifestyle`}>
                                            <div className={`collections-dots`}>
                                                <Svg id={`dots`} className={`svg__dots`} />
                                            </div>
                                            <div className={`lifestyle__wrappet-img`}>
                                                <img className={`lifestyle__text-img`}
                                                     src={`/storage/img/collections/minima/lifestyle.jpg`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                                <img className={``}
                                                     src={`/storage/img/collections/minima/foto-2-2.png`}
                                                     alt={`Красивое фото`}
                                                     title={`Красивое фото`}
                                                />
                                                <div className={`frame-face`}></div>
                                            </div>
                                        </div>
                                        <div className={`painting`}>
                                            <img className={``}
                                                 src={`/storage/img/collections/minima/painting.png`}
                                                 alt={`Роспись`}
                                                 title={`Роспись`}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id={`wrap_4`} className={`minima__wrap_4`}>
                        <div className={`container`}>
                            <div className={`random-decorations`}>
                                <img className={`minima-img minima-img__desktop minima-img__mobile`}
                                     src={`/storage/img/collections/minima/minima-img.png`}
                                     alt={`Фото`}
                                     title={`Фото`}
                                />
                                <div className={`random-decorations__left`}>
                                    <div className={`random-decorations__item random-decorations__item_1`}>
                                        <div
                                            className={`random-decorations__element random-decorations__element_1`}>
                                            <div className={`random-decorations__img random-decorations__img_1`}>
                                                <Link
                                                    href={`/catalog/product/02-4619-00-000-0200-71?utm_source=lp_minima&utm_medium=product_02-4619-00-000-0200-71&utm_campaign=l`}>
                                                    <img src={`/storage/img/collections/minima/earring_3.png`}
                                                         alt={`Красивое изображение`}
                                                         title={`Красивое изображение`}
                                                    />
                                                </Link>
                                            </div>
                                            <div className={`random-decorations__info random-decorations__info_1`}>
                                                Украшения напоминают кометы
                                            </div>
                                        </div>
                                        {isMobile() ?
                                            <div
                                                className={`random-decorations__element random-decorations__element_2`}>
                                                <div
                                                    className={`random-decorations__img random-decorations__img_2`}>
                                                    <Link
                                                        href={`/catalog/product/02-4618-00-000-0200-71?utm_source=lp_minima&utm_medium=product_02-4618-00-000-0200-71&utm_campaign=l`}>
                                                        <img src={`/storage/img/collections/minima/earring_6.png`}
                                                             alt={`Красивое изображение`}
                                                             title={`Красивое изображение`}
                                                        />
                                                    </Link>
                                                </div>
                                                <div
                                                    className={`random-decorations__info random-decorations__info_2`}>
                                                    Выразительно и&nbsp;целеустремлённо
                                                </div>
                                            </div>
                                            :
                                            <div
                                                className={`random-decorations__element random-decorations__element_2`}>
                                                <div
                                                    className={`random-decorations__img random-decorations__img_2`}>
                                                    <Link
                                                        href={`/catalog/product/02-4611-00-000-0200-71?utm_source=lp_minima&utm_medium=product_02-4611-00-000-0200-71&utm_campaign=l`}>
                                                        <img src={`/storage/img/collections/minima/earring_4.png`}
                                                             alt={`Красивое изображение`}
                                                             title={`Красивое изображение`}
                                                        />
                                                    </Link>
                                                </div>
                                                <div
                                                    className={`random-decorations__info random-decorations__info_2`}>
                                                    Полумесяц&nbsp;&mdash; это символ лунной Царицы Небес
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className={`random-decorations__item random-decorations__item_2`}>
                                        <div
                                            className={`random-decorations__element random-decorations__element_3`}>
                                            <div className={`random-decorations__img random-decorations__img_3`}>
                                                <Link
                                                    href={`/catalog/product/02-4615-00-000-0200-71?utm_source=lp_minima&utm_medium=product_02-4615-00-000-0200-71&utm_campaign=l`}>
                                                    <img src={`/storage/img/collections/minima/earring_5.png`}
                                                         alt={`Красивое изображение`}
                                                         title={`Красивое изображение`}
                                                    />
                                                </Link>
                                            </div>
                                            <div className={`random-decorations__info random-decorations__info_3`}>
                                                    <span>
                                                        Дизайн изящных серёг-пусетов в&nbsp;виде россыпи звёзд вдохновлён
                                                        созвездием Ориона
                                                    </span>
                                            </div>
                                        </div>
                                        {isMobile() ?
                                            <div
                                                className={`random-decorations__element random-decorations__element_4`}>
                                                <div
                                                    className={`random-decorations__img random-decorations__img_4`}>
                                                    <Link
                                                        href={`/catalog/product/02-4611-00-000-0200-71?utm_source=lp_minima&utm_medium=product_02-4611-00-000-0200-71&utm_campaign=l`}>
                                                        <img src={`/storage/img/collections/minima/earring_4.png`}
                                                             alt={`Красивое изображение`}
                                                             title={`Красивое изображение`}
                                                        />
                                                    </Link>
                                                </div>
                                                <div
                                                    className={`random-decorations__info random-decorations__info_4`}>
                                                    Полумесяц&nbsp;&mdash; это символ лунной Царицы Небес.
                                                </div>
                                            </div>
                                            :
                                            <div
                                                className={`random-decorations__element random-decorations__element_4`}>
                                                <div
                                                    className={`random-decorations__img random-decorations__img_4`}>
                                                    <Link
                                                        href={`/catalog/product/02-4618-00-000-0200-71?utm_source=lp_minima&utm_medium=product_02-4618-00-000-0200-71&utm_campaign=l`}>
                                                        <img src={`/storage/img/collections/minima/earring_6.png`}
                                                             alt={`Красивое изображение`}
                                                             title={`Красивое изображение`}
                                                        />
                                                    </Link>
                                                </div>
                                                <div
                                                    className={`random-decorations__info random-decorations__info_4`}>
                                                    Выразительно и&nbsp;целеустремлённо!
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className={`random-decorations__item random-decorations__item_3`}>
                                        <Link href={`/catalog/minima`}
                                                  className={`btn btn__all-decorations btn__minima`}
                                        >
                                            Все украшения
                                        </Link>
                                    </div>
                                </div>
                                <div className={`random-decorations__right`}>
                                    <p className={`text`}>
                                        Идея безграничного космоса
                                    </p>
                                    <Link
                                        href={`/catalog/product/07-0234-00-000-0200-71?utm_source=lp_minima&utm_medium=product_07-0234-00-000-0200-71&utm_campaign=l`}>
                                        <img src={`/storage/img/collections/minima/earring_7.png`}
                                             alt={`Красивое изображение`}
                                             title={`Красивое изображение`}
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<div className={`minima__wrap_5`}>*/}
                    {/*    <div className={`bg-banner`}></div>*/}
                    {/*    <div className={`container`}>*/}
                    {/*        <div className={`slider__collections-lp`}>*/}
                    {/*            {isDesktop() || isTablet() && (*/}
                    {/*                <div className={`beast-img`}>*/}
                    {/*                    <img className={``}*/}
                    {/*                         src={`/storage/img/collections/minima/slider/best.png`}*/}
                    {/*                         alt={`Красивое изображение`}*/}
                    {/*                         title={`Красивое изображение`}*/}
                    {/*                    />*/}
                    {/*                </div>*/}
                    {/*            )}*/}
                    {/*            <div className={`slider__image`}>*/}
                    {/*                <Slider ref={slider => (this.slider = slider)} {...settings}>*/}
                    {/*                    {element}*/}
                    {/*                </Slider>*/}
                    {/*            </div>*/}
                    {/*            <div className={`slider__content`}>*/}
                    {/*                <p className={`full-image__title`}>*/}
                    {/*                    Выиграй уникальный приз!*/}
                    {/*                </p>*/}
                    {/*                <a href="https://promo.platina-kostroma.shop/regform/"*/}
                    {/*                   className={`full-image__link btn btn__all-decorations btn__minima`}*/}
                    {/*                   target={`_blank`}*/}
                    {/*                >*/}
                    {/*                    Участвовать в розыгрыше*/}
                    {/*                </a>*/}
                    {/*                <p className={`full-image__conditions`}*/}
                    {/*                   onClick={() => modalStore.openModalConditionsPromotion()}>*/}
                    {/*                    <Svg id={`document`} className={`svg__document`} />*/}
                    {/*                    Условия акции*/}
                    {/*                </p>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div id={`wrap_6`} className={`minima__wrap_6`}>*/}
                    {/*    <div className={`container`}>*/}
                    {/*        {isMobile() ?*/}
                    {/*            <div className={`steps`}>*/}
                    {/*                <Slider ref={slider => (this.slider = slider)} {...settings1}>*/}
                    {/*                    {element1}*/}
                    {/*                </Slider>*/}
                    {/*            </div>*/}
                    {/*            :*/}
                    {/*            <div className={`steps`}>*/}
                    {/*                <div className={`steps__item`}>*/}
                    {/*                    <img src={`/storage/img/collections/minima/stepsslider/desktop-1.png`}*/}
                    {/*                         alt={`Отсканируй QR-код`}*/}
                    {/*                         title={`Отсканируй QR-код`}*/}
                    {/*                    />*/}
                    {/*                    <p className={`steps__info`}>Отсканируй QR-код</p>*/}
                    {/*                </div>*/}
                    {/*                <div className={`steps__item steps__item_2 steps__item_triple-chevron`}>*/}
                    {/*                    <img src={`/storage/img/collections/minima/stepsslider/desktop-arrows.png`}*/}
                    {/*                         alt={`Красивое фото`}*/}
                    {/*                         title={`Красивое фото`}*/}
                    {/*                    />*/}
                    {/*                </div>*/}
                    {/*                <div className={`steps__item`}>*/}
                    {/*                    <img src={`/storage/img/collections/minima/stepsslider/desktop-2-1.png`}*/}
                    {/*                         alt={`Заполни анкету`}*/}
                    {/*                         title={`Заполни анкету`}*/}
                    {/*                    />*/}
                    {/*                    <p className={`steps__info`}>Заполни анкету</p>*/}
                    {/*                </div>*/}
                    {/*                <div className={`steps__item steps__item_2 steps__item_triple-chevron`}>*/}
                    {/*                    <img src={`/storage/img/collections/minima/stepsslider/desktop-arrows.png`}*/}
                    {/*                         alt={`Красивое фото`}*/}
                    {/*                         title={`Красивое фото`}*/}
                    {/*                    />*/}
                    {/*                </div>*/}
                    {/*                <div className={`steps__item`}>*/}
                    {/*                    <img src={`/storage/img/collections/minima/stepsslider/desktop-3.png`}*/}
                    {/*                         alt={`Красивое фото`}*/}
                    {/*                         title={`Красивое фото`}*/}
                    {/*                    />*/}
                    {/*                    <p className={`steps__info`}>Участвуй в розыгрыше!</p>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        }*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </section>
        </>
    }
}

export default useWithStore(Minima);
